export default __webpack_public_path__ + "bc8b3286a5822dcdf7c2aa02cd7a3d82.webp";